var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2732 1.3648C12.2734 1.08042 12.1848 0.803083 12.0196 0.571591C11.8544 0.340099 11.621 0.166039 11.352 0.0737703C11.083 -0.0184983 10.7919 -0.0243585 10.5194 0.05701C10.2469 0.138378 10.0067 0.302904 9.83237 0.527561L0.287298 12.7998C0.101095 13.0392 0 13.3338 0 13.637C0 13.9403 0.101095 14.2349 0.287298 14.4743L9.83237 26.7465C10.0067 26.9712 10.2469 27.1357 10.5194 27.2171C10.7919 27.2984 11.083 27.2926 11.352 27.2003C11.621 27.108 11.8544 26.934 12.0196 26.7025C12.1848 26.471 12.2734 26.1936 12.2732 25.9093V20.4686C19.6079 20.6213 23.1314 22.0135 24.9013 23.5271C26.584 24.9657 26.8921 26.6579 27.2126 28.4305L27.2958 28.8873C27.3569 29.2142 27.5355 29.5074 27.7977 29.7119C28.06 29.9163 28.388 30.0179 28.7199 29.9974C29.0518 29.977 29.3648 29.836 29.6 29.6009C29.8352 29.3658 29.9764 29.0529 29.997 28.721C30.2302 24.9739 29.8797 19.5441 27.233 15.002C24.664 10.5935 20.0374 7.20366 12.2732 6.84912V1.3648Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtn);
export default __webpack_public_path__ + "static/media/back-btn.5078017c47c8708ec099738a4c0f8d48.svg";
export { ForwardRef as ReactComponent };